import * as React from 'react';
import { Button, Grid, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import CurrencyInput from "../../../../common/CurrencyInput/CurrencyInput";
import Busy from "../../../../Busy";
import request from '../../../../../util/SuperagentUtils';
import { CallbackActions } from "../../../../../util/ActionUtils";
import { getErrorMessageForStandardResponse } from "../../../../../util/NetworkErrorUtil";

interface AddRefundCreditModalProps {
  invoice: { transactionId: string };
  open: boolean;
  onInvoiceAction: (callbackActions: any, invoice?: any, message?: string) => void;
  onClose: (callbackActions?: any, invoice?: any, message?: string) => void;
}

const AddRefundCreditModal: React.FC<AddRefundCreditModalProps> = (props) => {
  const { invoice, open, onInvoiceAction, onClose } = props;
  const [refundCreditAmount, setRefundCreditAmount] = React.useState<number>(0);

  const handleClose = () => {
    setRefundCreditAmount(0);
    onClose();
  };

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const reasonForRefund = formData.get('reason') as string;

    const url = "api/invoices/add-refund-credit";
    const payload = {
      bookingTransactionId: invoice.transactionId,
      refundCreditAmount: refundCreditAmount,
      reasonForRefund
    };

    Busy.set(true);
    request.post(url).send(payload).then(() => {
      onClose(CallbackActions.SUCCESS, invoice, "Successfully added refund credit!");
    }).catch((error: any) => {
      onInvoiceAction(CallbackActions.ERROR, invoice, getErrorMessageForStandardResponse(error, ""));
    }).finally(() => {
      Busy.set(false);
    });
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        component: 'form',
        onSubmit
      }}
    >
      <DialogTitle>Add Refund Credit</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Enter the refund credit amount and reason for refund
        </DialogContentText>
        <CurrencyInput
          autoFocus
          required
          margin="dense"
          name="refundCreditAmount"
          label="Refund Credit Amount"
          helperText="Enter the amount to refund to this invoice."
          value={refundCreditAmount}
          onChange={setRefundCreditAmount}
          fullWidth
          variant="standard"
          inputProps={{ maxLength: 10 }}
        /><br /><br />
        <TextField
          required
          margin="dense"
          id="outlined-multiline-static"
          name="reason"
          label="Reason for Refund"
          helperText="Enter the reason this refund is being given."
          rows={10}
          fullWidth
          variant="standard"
        />
      </DialogContent>
      <DialogActions>
        <Grid container justifyContent={"center"}>
          <Button variant="text" onClick={handleClose} >Cancel</Button>
          <Button variant="contained" type="submit">Add Refund Credit</Button>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default AddRefundCreditModal;
